// LoginPage.js
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(form.email, form.password);
      toast.success(`Mirë se erdhe, ${data.user.name}!`);
      navigate(data.user.role === 'admin' ? '/admin' : from);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Gabim gjatë kyçjes');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">HairFix <span>Naturals</span></div>
        <h1 className="auth-title">Mirë se u kthye</h1>
        <p className="auth-sub">Kyçu për të vazhduar</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" required placeholder="email@juaj.com" value={form.email} onChange={e => setForm({...form,email:e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Fjalëkalimi</label>
            <input className="form-input" type="password" required placeholder="••••••••" value={form.password} onChange={e => setForm({...form,password:e.target.value})} />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Duke u kyçur...' : 'Kyçu'}
          </button>
        </form>
        <p className="auth-switch">
          Nuk ke llogari? <Link to="/register">Regjistrohu</Link>
        </p>
      </div>
      <style>{`
        .auth-page{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:100px 24px 60px;background:linear-gradient(135deg,var(--green-deep) 0%,var(--green-mid) 100%);}
        .auth-card{background:white;border-radius:var(--radius-xl);padding:40px;width:min(420px,100%);box-shadow:var(--shadow-lg);}
        .auth-logo{font-family:'Playfair Display',serif;font-size:1.2rem;font-weight:700;color:var(--green-deep);margin-bottom:28px;}
        .auth-logo span{color:var(--gold);font-style:italic;}
        .auth-title{font-size:1.6rem;margin-bottom:6px;}
        .auth-sub{color:var(--text-light);font-size:.9rem;margin-bottom:28px;}
        .auth-switch{text-align:center;margin-top:20px;font-size:.88rem;color:var(--text-light);}
        .auth-switch a{color:var(--green-mid);font-weight:600;}
      `}</style>
    </div>
  );
}

export function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name:'', email:'', password:'', phone:'' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('Fjalëkalimi duhet të ketë të paktën 6 karaktere'); return; }
    setLoading(true);
    try {
      const data = await register(form.name, form.email, form.password, form.phone);
      toast.success(`Mirë se erdhe, ${data.user.name}!`);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Gabim gjatë regjistrimit');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">HairFix <span>Naturals</span></div>
        <h1 className="auth-title">Krijo Llogarinë</h1>
        <p className="auth-sub">Bashkohu me komunitetin tonë</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label className="form-label">Emri i Plotë</label>
            <input className="form-input" required placeholder="Emri Mbiemri" value={form.name} onChange={e => setForm({...form,name:e.target.value})} />
          </div>
          <div className="form-group"><label className="form-label">Email</label>
            <input className="form-input" type="email" required placeholder="email@juaj.com" value={form.email} onChange={e => setForm({...form,email:e.target.value})} />
          </div>
          <div className="form-group"><label className="form-label">Telefoni (opsionale)</label>
            <input className="form-input" type="tel" placeholder="+383..." value={form.phone} onChange={e => setForm({...form,phone:e.target.value})} />
          </div>
          <div className="form-group"><label className="form-label">Fjalëkalimi</label>
            <input className="form-input" type="password" required placeholder="Minimum 6 karaktere" value={form.password} onChange={e => setForm({...form,password:e.target.value})} />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Duke u regjistruar...' : 'Regjistrohu'}
          </button>
        </form>
        <p className="auth-switch">Ke llogari? <Link to="/login">Kyçu</Link></p>
      </div>
      <style>{`
        .auth-page{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:100px 24px 60px;background:linear-gradient(135deg,var(--green-deep) 0%,var(--green-mid) 100%);}
        .auth-card{background:white;border-radius:var(--radius-xl);padding:40px;width:min(420px,100%);box-shadow:var(--shadow-lg);}
        .auth-logo{font-family:'Playfair Display',serif;font-size:1.2rem;font-weight:700;color:var(--green-deep);margin-bottom:28px;}
        .auth-logo span{color:var(--gold);font-style:italic;}
        .auth-title{font-size:1.6rem;margin-bottom:6px;}
        .auth-sub{color:var(--text-light);font-size:.9rem;margin-bottom:28px;}
        .auth-switch{text-align:center;margin-top:20px;font-size:.88rem;color:var(--text-light);}
        .auth-switch a{color:var(--green-mid);font-weight:600;}
      `}</style>
    </div>
  );
}
